// extracted by mini-css-extract-plugin
module.exports = {"content":"SectionContentsBody_content__r33ns","content--body":"SectionContentsBody_content--body__2n4HQ"};